module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-10-19 at 5.18.23 PM.31d89501.png";